import { spacings } from "@/assets/themes";
import { Block, Body16, Divider, H1 } from "@/components";
import { useJobAvailableHours } from "@/modules/hooks";
import { JOB_MAX_HOUR, JOB_MIN_HOUR } from "@/utils";
import polyglot from "@/utils/polyglot";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { INPUT } from "@/components/Styles/variants";
import { getMainParentCategoryById } from "../categoriesNavigationModal/utils";
import { FormFromTo, StyledFormControl } from "../categoryForms/common/fields";
import StepTitle from "../categoryForms/common/StepTitle";
import { CATEGORY_DATE_FORMAT } from "../categoryForms/constants";
import { getHourDiff } from "../categoryForms/utils";

const TimeHoursSelection = ({ title }) => {
  const { values, setFieldValue, errors } = useFormikContext();
  const { getOptions } = useJobAvailableHours({ format: CATEGORY_DATE_FORMAT });

  const getHours = () => {
    if (
      values.category &&
      getMainParentCategoryById(values.category)?.id !== 28
    ) {
      return [JOB_MIN_HOUR, JOB_MAX_HOUR];
    }
    return [0, 23.5];
  };

  useEffect(() => {
    if (values.start_hour && values.end_hour) {
      setFieldValue(
        "nb_hours",
        getHourDiff(values.start_hour, values.end_hour)
      );
    }
  }, [values]);

  return (
    <>
      <StepTitle>{title}</StepTitle>
      <StyledFormControl
        error={
          values.start_hour && values.end_hour && errors.nb_hours
            ? errors.nb_hours
            : undefined
        }
      >
        <FormFromTo
          names={["start_hour", "end_hour"]}
          placeholders={[
            polyglot.toTime(JOB_MIN_HOUR),
            polyglot.toTime(JOB_MAX_HOUR),
          ]}
          size={INPUT.SIZE.LARGE}
          LeftComponents={[
            () => <Body16 strong>{polyglot.t("common.beginning")}</Body16>,
            () => <Body16 strong>{polyglot.t("common.end")}</Body16>,
          ]}
          options={[
            getOptions({
              date: values.start_date,
              min: getHours()[0],
              max: getHours()[1],
              ignoreCurrentHour: true,
            }),
            getOptions({
              date: values.start_date,
              min: getHours()[0],
              max: getHours()[1],
              ignoreCurrentHour: true,
            }),
          ]}
        />
      </StyledFormControl>
      {values.start_hour > 0 && values.end_hour > 0 && (
        <>
          <Block paddingY={spacings.l}>
            <Divider.Cell />
          </Block>
          <Block
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
          >
            <Body16 strong align="center">
              {polyglot.t("common.duration")}
            </Body16>
            <H1 align="center">{polyglot.toDuration(values.nb_hours, true)}</H1>
          </Block>
        </>
      )}
    </>
  );
};

export default TimeHoursSelection;
